import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 35805 30445"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:518.914}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528318546560">
        <path
          d="M33527 1587H2278c-135 0-245-109-245-245 0-135 110-244 245-244h31249c135 0 245 109 245 244 0 136-110 245-245 245z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 518.914,
          }}
        />
        <path
          d="M1342 749c-326 0-593 267-593 593 0 327 267 594 593 594 328 0 594-267 594-594 0-326-267-593-594-593zm0 1676c-597 0-1083-485-1083-1083 0-597 486-1083 1083-1083 598 0 1084 486 1084 1083 0 598-486 1083-1084 1083zM34463 749c-328 0-593 267-593 593 0 327 265 594 593 594 327 0 592-267 592-594 0-326-265-593-592-593zm0 1676c-598 0-1084-485-1084-1083 0-597 486-1083 1084-1083 596 0 1083 486 1083 1083 0 598-487 1083-1083 1083zM32713 30185H16531V1387c0-135 109-245 244-245 136 0 245 110 245 245v28308h15203V1387c0-135 109-245 245-245 135 0 245 110 245 245v28798z"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 518.914,
          }}

        />
        <path
          d="M17020 19030H3091V1387c0-135 110-245 246-245 135 0 245 110 245 245v17153h12949V1387c0-135 109-245 244-245 136 0 245 110 245 245v17643zM29598 28400c-136 0-245-110-245-245V8163c0-135 109-245 245-245 135 0 245 110 245 245v19992c0 135-110 245-245 245zM26303 28400c-135 0-245-110-245-245V14867c0-135 110-245 245-245 136 0 245 110 245 246v13287c0 135-109 245-245 245z"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 518.914,
          }}

        />
        <path
          d="M6015 11183c-53 0-105-18-150-52-107-82-127-236-44-343l4682-6070c82-107 236-127 343-44 108 83 127 236 45 344l-4682 6069c-48 62-121 96-194 96zM6015 15459c-56 0-113-19-159-58-103-88-115-242-27-346l9128-10692c87-104 243-116 345-28 104 88 115 242 28 346L6202 15374c-49 56-118 85-187 85zM10461 15113c-52 0-105-17-150-51-107-83-127-237-44-344l4682-6069c83-107 237-127 344-44 107 82 127 236 44 343l-4682 6069c-48 63-121 96-194 96zM23009 28400c-136 0-245-110-245-245v-7854c0-135 109-245 245-245 135 0 245 110 245 245v7854c0 135-110 245-245 245z"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 518.914,
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
